import PrimaryVerification from './components/PrimaryVerification';
import SeniorVerification from './components/SeniorVerification';
import Result from './components/Result';
import Continue from './components/Continue';

import Authorize from './components/Authorize';

export const components = { PrimaryVerification, SeniorVerification, Result, Continue, Authorize };

const _PrimaryVerification = {
  component: 'PrimaryVerification',
  ['el-dialog']: {},
  ['el-drawer']: {
    size: '100%',
  },
  allowBack: false,
  allowClose: true,
  next: 'SeniorVerification',
};
const _SeniorVerification = {
  component: 'SeniorVerification',
  ['el-dialog']: {},
  ['el-drawer']: {
    size: '100%',
  },
  allowClose: true,
  allowBack: true,
};
const _Result = {
  component: 'Result',
  ['el-dialog']: {},
  ['el-drawer']: {
    size: '100%',
  },
  allowClose: true,
  // allowBack: true,
};
const _Continue = {
  component: 'Continue',
  ['el-dialog']: {},
  ['el-drawer']: {
    size: '100%',
  },
  allowClose: true,
  allowBack: true,
};

const _Authorize = {
  component: 'Authorize',
  ['el-dialog']: {},
  ['el-drawer']: {
    size: '100%',
  },
  allowClose: false,
  allowBack: false,
  showSkip: true,
};

export const componentsChain = { _PrimaryVerification, _Result, _Continue, _SeniorVerification, _Authorize };

export const chain1 = [_PrimaryVerification, _Result, _Continue, _SeniorVerification];
export const chain2 = [_Continue, _SeniorVerification];
